import { Component, OnInit } from '@angular/core';
import { FirebaseListObservable } from 'angularfire2/database-deprecated';
import { PostService } from '../model/post.service';

@Component({
  selector: 'recent-posts',
  templateUrl: './recent-posts.component.html',
  styleUrls: ['./recent-posts.component.css']
})
export class RecentPostsComponent implements OnInit {
  recentPosts: FirebaseListObservable<PostService[]>;
  key: string;
  ref: any;
  constructor() {

  }
  loadRecentPosts() {
    let response = {};
    response["ref"] = this.ref;
    response["key"] = this.key;
  }
  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/recent-posts/recent-posts.component.ts